import React from "react";
import { Box, ToggleButton } from "@mui/material";
import { workspaceSwitchSx } from "../../../../Dashboard/overviewPanel";
import { hapticSelection } from "../../../../../lib/haptics";

interface ChartToggleButtonProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
  color?: string;
  icon?: React.ReactNode;
}

const ChartToggleButton: React.FC<ChartToggleButtonProps> = ({
  label,
  selected,
  onToggle,
  color,
  icon,
}) => {
  const dotOpacity = selected ? 1 : 0.4;
  return (
    <Box sx={{ ...workspaceSwitchSx, display: "inline-flex" }}>
      <ToggleButton
        value={label}
        selected={selected}
        onClick={() => {
          hapticSelection();
          onToggle();
        }}
        sx={{ gap: 0.75, whiteSpace: "nowrap" }}
      >
        {color && (
          <Box
            component="span"
            sx={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              bgcolor: color,
              opacity: dotOpacity,
            }}
          />
        )}
        {icon}
        {label}
      </ToggleButton>
    </Box>
  );
};

export default ChartToggleButton;
